import { useCallback, useEffect, useState } from 'react';
import apiClient from '../../../../utils/apiClient';

// Merged under the response so every card can read its slice without a guard.
const EMPTY = {
  profile: { name: '', role: '', avatar: '', email: '', mobile: '', skills: [] },
  stats: { studentsMentored: 0, activeCourses: 0, activeBatches: 0, totalBatches: 0 },
  today: { classesToday: 0, scheduleDay: '', isTomorrow: false, nextClass: null, schedule: [], assignmentsPending: 0 },
  batches: [],
  analytics: {},
  attendanceTrend: [],
  recentActivity: [],
};

/**
 * The trainer's `/instructors/me/dashboard-summary`.
 *
 * `data` stays null until a load succeeds, so a first load that fails is an
 * error the page can say, not a dashboard of zeros. A REFRESH that fails keeps
 * what is on screen: the page refetches on every class start/end event, and one
 * dropped request must not blank a dashboard that was right a second ago.
 */
export default function useTrainerDashboard() {
  const [data, setData] = useState(null);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  const fetchDashboard = useCallback(async () => {
    setLoading(true);
    try {
      const res = await apiClient.get('/instructors/me/dashboard-summary');
      const body = res?.data || {};
      setData({ ...EMPTY, ...body, today: { ...EMPTY.today, ...(body.today || {}) } });
      setError(null);
    } catch (e) {
      setError(e);
    } finally {
      setLoading(false);
    }
  }, []);

  useEffect(() => { fetchDashboard(); }, [fetchDashboard]);

  return { data, loading, error, refetch: fetchDashboard };
}
